import {
  Project,
  StudioProjectVersion,
} from '../../../server/graphql/__generated.types';
import { ProjectFragment } from '../fragments.generated';

const CJK_PROJECT_VERSIONS = [
  StudioProjectVersion.AzureJapanese,
  StudioProjectVersion.AzureKorean,
  StudioProjectVersion.AzureChinese,
];

const MENA_PROJECT_VERSIONS = [
  StudioProjectVersion.AzureArabic,
  StudioProjectVersion.AzurePersian,
  StudioProjectVersion.AzureTurkish,
];

const EU_AZURE_PROJECT_VERSIONS = [
  StudioProjectVersion.AzureDutch,
  StudioProjectVersion.AzureCzech,
  StudioProjectVersion.AzurePolish,
  StudioProjectVersion.AzureDanish,
  StudioProjectVersion.AzureSwedish,
];

/**
 * @description This hook evaluates the project version and returns the features that are available for the project.
 * @note replacements feature is not available for CJK projects and will override a users feature ability check
 */
const useEvaluateStudioProjectVersionFeatures = (
  project: Project | ProjectFragment | { studioVersion?: StudioProjectVersion }
) => {
  const withinCJK = CJK_PROJECT_VERSIONS.includes(project.studioVersion!);
  const withinMENA = MENA_PROJECT_VERSIONS.includes(project.studioVersion!);
  const withinEU_AZURE = EU_AZURE_PROJECT_VERSIONS.includes(
    project.studioVersion!
  );

  return {
    searchDisabled: withinCJK || withinMENA,
    replacementsDisabled: withinCJK || withinMENA,
    renderMultipleClipsDisabled: withinCJK,
    downloadCaptionsDisabled: withinCJK || withinMENA,
    floatingPhoneticReplacementDisabled:
      withinCJK || withinMENA || withinEU_AZURE,
    importScriptDisabled: withinCJK || withinMENA,
  };
};

export default useEvaluateStudioProjectVersionFeatures;
